export const MissionsPage = ({children}) => {
  const styles = {
    backgroundImage: 'url(/assets/missions-header.png)',
    backgroundSize: 'contain',
    backgroundPosition: 'top',
    backgroundRepeat: 'no-repeat'
  };
  return <div className='page' style={styles}>{children}</div>
}